import { render } from "./footerApp.vue?vue&type=template&id=32922d60&scoped=true"
import script from "./footerApp.vue?vue&type=script&lang=js"
export * from "./footerApp.vue?vue&type=script&lang=js"

import "./footerApp.vue?vue&type=style&index=0&id=32922d60&scoped=true&lang=stylus"

import exportComponent from "F:\\OneDrive\\Рабочий стол\\cleancutmeals\\cleancutmeals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32922d60"]])

export default __exports__